import React from "react";
import lazyPage from "../../../../../common/helpers/lazyPage";
import LoadingFrame from "../../../LoadingFrame";
export default lazyPage(
    "src/front/components/Task/types/Singing/singing.tsx",
    () => import("./singing"),
    <LoadingFrame />,
);
